import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import { FaBars, FaBell, FaSearch } from "react-icons/fa";

const pageTitles = {
  "/admin/dashboard": { title: "Dashboard", sub: "Welcome back!" },
  "/admin/contacts": { title: "Contacts", sub: "Manage enquiries" },
  "/admin/services": { title: "Services", sub: "Manage your services" },
  "/admin/portfolio": { title: "Portfolio", sub: "Manage projects" },
  "/admin/team": { title: "Team", sub: "Manage team members" },
  "/admin/testimonials": { title: "Testimonials", sub: "Manage client reviews" },
};

export default function AdminLayout({ onLogout }) {
  const [open, setOpen] = useState(false);
  const admin = JSON.parse(localStorage.getItem("adminUser") || "{}");
  const location = useLocation();
  const page = pageTitles[location.pathname] || { title: "Admin", sub: "" };

  return (
    <div className="min-h-screen flex" style={{ background: "#060b18" }}>
      <AdminSidebar open={open} setOpen={setOpen} onLogout={onLogout} />

      <div className="flex-1 lg:ml-64 flex flex-col min-h-screen">
        {/* Topbar */}
        <header className="sticky top-0 z-20 flex items-center justify-between px-4 sm:px-6 py-3.5 border-b border-white/5"
          style={{ background: "rgba(6,11,24,0.95)", backdropFilter: "blur(20px)" }}>

          <div className="flex items-center gap-4">
            <button onClick={() => setOpen(true)} className="lg:hidden text-gray-400 hover:text-white transition-colors">
              <FaBars className="text-lg" />
            </button>
            <div className="hidden sm:block">
              <h1 className="text-white font-bold text-base">{page.title}</h1>
              <p className="text-gray-500 text-xs">{page.sub}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {/* Notification bell */}
            <button className="w-9 h-9 rounded-xl flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/5 transition-all relative">
              <FaBell className="text-sm" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-blue-500 rounded-full" />
            </button>

            {/* Admin avatar */}
            <div className="flex items-center gap-2.5 pl-3 border-l border-white/10">
              <div className="w-8 h-8 gradient-bg rounded-xl flex items-center justify-center text-white text-sm font-black shadow-lg shadow-blue-500/20">
                {admin.name?.[0]?.toUpperCase() || "A"}
              </div>
              <div className="hidden sm:block">
                <p className="text-white text-xs font-semibold">{admin.name || "Admin"}</p>
                <p className="text-gray-500 text-xs">{admin.email}</p>
              </div>
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 p-4 sm:p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
